export function getDataFromPage(id: string) {
  const scriptEl = document.getElementById(id);
  if (!scriptEl) return console.warn(`Could not find page data: ${id}`);
  return JSON.parse(scriptEl.innerText);
}

export const pressedEnter = (e: React.KeyboardEvent, callback: () => void) => {
  if (e.key !== 'Enter') return;
  callback();
};
